exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popover[data-v-1b8d1463] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2001;\n  max-width: 500px;\n  border: solid 1px #E4E7ED;\n  border-radius: 4px;\n  max-height: 400px;\n  background-color: #FFFFFF;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n  overflow-y: auto !important;\n  margin-top: 3rem;\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.itemsList[data-v-1b8d1463] {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n", ""]);

// exports
